import { Trans } from '@lingui/react/macro';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/videa-components/src/index';

import { DatePickerWithRange } from '../../../../common-components/elements/DatePickerWithRange/DatePickerWithRange';
import { PatientListPageLayoutContextMap } from '../../../../modules/patientList/types';
import { useReferralsFilters } from '../../../../modules/referrals/hooks/useReferralsFilters';
import { PatientSearch } from '../PatientSearch';

export const ReferralsTopbarContent = () => {
  const {
    // State
    selectedSpecialty,
    selectedStatus,
    selectedLocation,
    selectedDateRange,
    customDateRange,

    // Options
    specialtyOptions,
    statusOptions,
    locationOptions,
    dateRangeOptions,

    // Display values
    getSpecialtyDisplayValue,
    getStatusDisplayValue,
    getLocationDisplayValue,
    getDateRangeDisplayValue,

    // Handlers
    handleSpecialtyChange,
    handleStatusChange,
    handleLocationChange,
    handleDateRangeChange,
    handleCustomDateRangeChange,
  } = useReferralsFilters();

  return (
    <>
      {/* Search Bar */}
      <div className="vai-min-w-32 vai-max-w-64">
        <PatientSearch context={PatientListPageLayoutContextMap.Referrals} />
      </div>

      {/* Filters */}
      <div className="vai-flex vai-items-center vai-gap-2">
        <Select value={selectedSpecialty} onValueChange={handleSpecialtyChange}>
          <SelectTrigger className="!vai-w-[220px] vai-py-2 vai-text-sm vai-border-gray-200 vai-rounded-md vai-flex vai-items-center vai-gap-0 vai-overflow-hidden">
            <span className="vai-text-sm vai-font-semibold vai-text-gray-700 vai-flex-shrink-0 vai-mr-2">
              <Trans>Specialty:</Trans>
            </span>
            <SelectValue className="vai-flex-1 vai-min-w-0 vai-overflow-hidden vai-truncate">
              {getSpecialtyDisplayValue}
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            {specialtyOptions.map((specialty) => (
              <SelectItem key={specialty.value} value={specialty.value}>
                <span className="vai-block vai-w-full">{specialty.label}</span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={selectedStatus} onValueChange={handleStatusChange}>
          <SelectTrigger className="!vai-w-[220px] vai-py-2 vai-text-sm vai-border-gray-200 vai-rounded-md vai-px-3 vai-flex vai-items-center vai-gap-0 vai-overflow-hidden">
            <span className="vai-text-sm vai-font-semibold vai-text-gray-700 vai-flex-shrink-0 vai-mr-2">
              <Trans>Status:</Trans>
            </span>
            <SelectValue className="vai-flex-1 vai-min-w-0 vai-overflow-hidden vai-truncate">
              {getStatusDisplayValue}
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            {statusOptions.map((status) => (
              <SelectItem key={status.value} value={status.value}>
                <span className="vai-block vai-w-full">{status.label}</span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={selectedLocation} onValueChange={handleLocationChange}>
          <SelectTrigger className="!vai-w-[220px] vai-py-2 vai-text-sm vai-border-gray-200 vai-rounded-md vai-px-3 vai-flex vai-items-center vai-gap-0 vai-overflow-hidden">
            <span className="vai-text-sm vai-font-semibold vai-text-gray-700 vai-flex-shrink-0 vai-mr-2">
              <Trans>Specialty Practice:</Trans>
            </span>
            <SelectValue className="vai-flex-1 vai-min-w-0 vai-overflow-hidden vai-truncate">
              {getLocationDisplayValue}
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            {locationOptions.map((location) => (
              <SelectItem key={location.value} value={location.value}>
                <span className="vai-block vai-w-full">{location.label}</span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={selectedDateRange} onValueChange={handleDateRangeChange}>
          <SelectTrigger className="!vai-w-[220px] vai-py-2 vai-text-sm vai-border-gray-200 vai-rounded-md vai-px-3 vai-flex vai-items-center vai-gap-0 vai-overflow-hidden">
            <span className="vai-text-sm vai-font-semibold vai-text-gray-700 vai-flex-shrink-0 vai-mr-2">
              <Trans>Time Range:</Trans>
            </span>
            <SelectValue className="vai-flex-1 vai-min-w-0 vai-overflow-hidden vai-truncate">
              {getDateRangeDisplayValue}
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            {dateRangeOptions.map((range) => (
              <SelectItem key={range.value} value={range.value}>
                <span className="vai-block vai-w-full">{range.label}</span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* Custom Date Range Picker - Show when custom is selected */}
        {selectedDateRange === 'custom' && (
          <DatePickerWithRange
            date={customDateRange}
            setDate={handleCustomDateRangeChange}
            className="vai-w-auto"
          />
        )}
      </div>
    </>
  );
};
